/**
 * Component to Show Formula Calculation
 *
 *
 * @author Nihala Dilshi
 * 
 * @author Ashique
 * 
 */

import React, { useState, useEffect } from 'react';

import { Appointments } from '../../models';

import { useTranslation } from 'soxo-bootstrap-core';

import { Table, Card, Button, Modal, Select, Form, Skeleton } from 'antd';

import './formula.scss';

const { Option } = Select;


export default function Formula({ code, mode, caption, opbill, itemValue, inputParameters, item = {}, callback }) {


    // Variable to control the open/close of the modal
    const [visible, setVisible] = useState(false);

    useEffect(() => {

    }, []);

    /**
     * Toggle the modal
     */
    const viewFormula = () => {

        setVisible(true);
    }
    const applyFormula = (value) => {
        callback(value);
    }
    const { t, i18n } = useTranslation(); // To Translate to another language

    return (
        <>

            <Button size="small" class="btn" onClick={viewFormula}>
                <i class="fa fa-calculator"></i> {caption}
            </Button>

            {/* Modal for Viewing Formula calculation */}
            <>
                <Modal
                    width={'70%'}
                    destroyOnClose={true}
                    footer={null}
                    title={t("CALCULATOR")}
                    active={visible}
                    visible={visible}
                    okText="Okay"
                    onOk={() => {
                        setVisible(false)
                    }}
                    onCancel={() => {
                        setVisible(false)
                    }}
                >
                    <FormulaCalculator
                        code={code}
                        mode={mode}
                        guest={opbill}
                        itemValue={itemValue}
                        inputParameters={inputParameters}

                        callback={(values) => {
                            setVisible(false)
                            applyFormula(values);
                        }}
                        item={item}
                    />
                </Modal>
            </>
        </>
    );
}

/**
 * Formula Calculator
 * 
 * @param {*} param0 
 * @returns 
 */
function FormulaCalculator({ code, itemValue, mode, guest = {}, inputParameters = {}, callback }) {

    // Variable to hold the formula and its results
    const [results, setResults] = useState([]);
    const [value, setValue] = useState();
    const [loading, setLoading] = useState();


    const { t, i18n } = useTranslation(); // To Translate to another language


    useEffect(() => {

        loadFormula();

    }, [])

    /**
     * Load the formula for the code
     * 
     * @param {*} code 
     */
    async function loadFormula() {

        setLoading(true);

        // Get the fomula for the particular code
        // const formula = await Appointments.getFormula(code);

        // Prepare the values as per the formula
        // let results = await prepareFormula(formula, inputParameters);

        /**Preparing the formbody */
        let formBody = {
            body: itemValue,
            billid: guest.opb_id,
            mode: mode
        }

        // Get the fomula for the particular code
        const results = await Appointments.getFormula(formBody);

        setLoading(false);

        // Set the results
        setValue(results.data.result)
        setResults(results.data.table_data);

    }

    /**
     * Replace the formala with input parameters
     * 
     * @param {*} record 
     * @param {*} inputParameters 
     * @returns 
     */
    
   
    const formulaColumns = [
        {
            title: '#',
            key: 'slno',
            render: (ele, _, index) => <div>{index + 1}</div>
        }
    ];

    // Dynamically create columns based on the keys of first data object
    if (results.length > 0) {
        Object.keys(results[0]).forEach(key => {
            formulaColumns.push({
                title: t(key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())), // optional: format key nicely
                key: key,
                render: ele => {
                    const value = ele[key]?.[0] ?? '';  // safely get the first element of the array
                    if (key === 'gender') {
                        return <div>{value === 'M' ? 'Male' : 'Female'}</div>;
                    }
                    return <div>{value}</div>;
                }
            });
        });
        formulaColumns.push({
            title: t('Value'),
            key: 'result',
            render: ele => {
                // const record = ele.result?.[0] ?? '';
                return (
                    <div className="formula">
                        <div className="background-style">{value}</div>
                    </div>
                );
            }
        });
    }


    const applyFormula = () => {
        callback(value);
    }


    const cancelFormula = () => {
        callback()
    }

    return (<>

        <div className="detail-element">
            <div className="top-section">
                <div className="summary-bottom" style={{ width: '30%' }}>
                    <div className="right">
                        <Form layout="vertical">
                            <Form.Item name="selected"
                                rules={[{ required: true, message: t('Please select value type ') }]}
                                label={t("VALUE TYPE")}>
                                <div className=''>
                                    <Select
                                        // value={'eGFR'}
                                        value={code}
                                        allowClear
                                        style={{ width: '60%' }}
                                    >
                                        {/* <Option value={'eGFR'}>{t('eGFR')}</Option> */}
                                        <Option value={code}>{t(code)}</Option>
                                    </Select>
                                </div>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>

            {loading ? (
                <div className="skeleton-wrapper card card-shadow guest-info">
                    <Skeleton active />
                </div>
            ) : (
                <Card className="table-card">
                    <Table
                        scroll={{ x: true }}
                        rowKey={(record, key) => key}
                        pagination={false}
                        dataSource={results}
                        columns={formulaColumns}

                    />
                </Card>
            )}

            <div>
                <Button
                    size="small"
                    type="primary"
                    onClick={applyFormula}

                >
                    {' '}
                    {t('Apply')}
                </Button>

                <Button
                    style={{ marginLeft: '20px' }}
                    size="small"
                    type="secondary"
                    onClick={cancelFormula}

                >
                    {' '}
                    {t('Cancel')}
                </Button>
            </div>
        </div>


    </>)

}
